module.exports = __webpack_public_path__ + "media/soundtrack.2b94caba.mp3";